import type { KataId } from '../data/catalog/types'
import type { NoteDocument } from './notes/document'
import type { ElementMarkState } from '../lib/scoring/engine'
import { RULE_TABLE_VERSION } from '../data/scoring'

export const SCHEMA_VERSION = 4 as const

export type VideoProvider = 'youtube'

export interface TechniqueSegment {
  techniqueId: string
  startSeconds: number
  endSeconds: number
}

export interface VideoReference {
  id: string
  kataId: KataId
  title: string
  provider: VideoProvider
  videoId: string
  segments: TechniqueSegment[]
  createdAt: string
  updatedAt: string
}

/**
 * Personal note for a technique.
 * `content` is a BlockNote document (block JSON) — never treat as HTML.
 */
export interface TechniqueNote {
  id: string
  kataId: KataId
  techniqueId: string
  content: NoteDocument
  createdAt: string
  updatedAt: string
}

export interface Favourite {
  id: string
  kataId: KataId
  techniqueId: string
  createdAt: string
}

export interface AppPreferences {
  lastKataId?: KataId
  lastTechniqueId?: string
  /**
   * When true (default), defer the YouTube iframe until load/play.
   * Explicit `false` loads the player immediately.
   */
  deferYoutubeLoad?: boolean
}

/** One practice judging run (local; multiple per kata). */
export interface KataPerformance {
  id: string
  kataId: KataId
  status: 'draft' | 'completed'
  createdAt: string
  updatedAt: string
  completedAt?: string
  scoredBy?: string
  note?: string
  ruleTableVersion: typeof RULE_TABLE_VERSION | string
  judgeCount: 1
  elementMarks: ElementMarkState[]
  rawTotal: number
  forgottenPenaltyApplied: boolean
  finalTotal: number
  maxTotal: number
}

export interface PersonalStoreSnapshot {
  schemaVersion: typeof SCHEMA_VERSION
  references: VideoReference[]
  notes: TechniqueNote[]
  favourites: Favourite[]
  preferences: AppPreferences
  performances: KataPerformance[]
}

export function personalRecordId(kataId: KataId, techniqueId: string): string {
  return `${kataId}::${techniqueId}`
}
